import { BaseDb } from "common/BaseDb"
import { PlanscanSchemaWithId } from "components/planscan/planscan.schema"

export class PlanscanDb extends BaseDb<PlanscanSchemaWithId> {}

export default new PlanscanDb("planscan")
